enum CostModifierPerUnitId {
    CONSECRATE = 'CONSECRATE',
    ORDINANCE_COMPANY = 'ORDINANCE_COMPANY'
}

export default CostModifierPerUnitId;